import React from "react";
import {
  H2,
  H3,
  P,
  A,
  Strong,
  Ul,
  Ol,
  Li,
  Quote,
  Callout,
  Code,
  Pre,
  Divider,
  Figure,
} from "./prose";

/**
 * scripts/sync-notion-newsletters.mjs 가 정규화해서 내려주는 블록 JSON을 렌더한다.
 * Notion 원본 스키마가 아니라 자체 정규화 스키마를 받기 때문에,
 * Notion API가 바뀌어도 이 렌더러는 그대로 둘 수 있다.
 *
 * 블록 스키마: { type, text?: RichText[], items?: RichText[][], url?, caption?, code? }
 * RichText:   { content, bold?, italic?, code?, link? }
 */

function RichText({ parts }) {
  if (!parts || parts.length === 0) return null;

  return (
    <>
      {parts.map((part, i) => {
        let node = part.content;

        if (part.code) node = <Code key={`c${i}`}>{node}</Code>;
        if (part.bold) node = <Strong key={`b${i}`}>{node}</Strong>;
        if (part.italic) node = <em key={`i${i}`}>{node}</em>;
        if (part.link) {
          node = (
            <A key={`l${i}`} href={part.link}>
              {node}
            </A>
          );
        }

        return <React.Fragment key={i}>{node}</React.Fragment>;
      })}
    </>
  );
}

function Block({ block }) {
  switch (block.type) {
    case "heading_1":
    case "heading_2":
      return (
        <H2>
          <RichText parts={block.text} />
        </H2>
      );
    case "heading_3":
      return (
        <H3>
          <RichText parts={block.text} />
        </H3>
      );
    case "paragraph":
      if (!block.text || block.text.length === 0) return null;
      return (
        <P>
          <RichText parts={block.text} />
        </P>
      );
    case "bulleted_list":
      return (
        <Ul>
          {block.items.map((item, i) => (
            <Li key={i}>
              <RichText parts={item} />
            </Li>
          ))}
        </Ul>
      );
    case "numbered_list":
      return (
        <Ol>
          {block.items.map((item, i) => (
            <Li key={i}>
              <RichText parts={item} />
            </Li>
          ))}
        </Ol>
      );
    case "quote":
      return (
        <Quote>
          <RichText parts={block.text} />
        </Quote>
      );
    case "callout":
      return (
        <Callout>
          <RichText parts={block.text} />
        </Callout>
      );
    case "code":
      return <Pre>{block.code}</Pre>;
    case "image":
      return (
        <Figure>
          <img src={block.url} alt={block.caption || ""} loading="lazy" />
          {block.caption ? <figcaption>{block.caption}</figcaption> : null}
        </Figure>
      );
    case "divider":
      return <Divider />;
    default:
      // 아직 지원하지 않는 블록 타입은 조용히 건너뛴다.
      return null;
  }
}

function NotionBlocks({ blocks }) {
  if (!blocks || blocks.length === 0) return null;

  return (
    <>
      {blocks.map((block, i) => (
        <Block key={i} block={block} />
      ))}
    </>
  );
}

export default NotionBlocks;
